/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class EvaluateTemplate extends Ce {
    constructor() {
        super();
        this.baseUrl += '/evaluateTemplate';
    }

    data({ templateName, isAvailable, currentPage, pageSize } = {}) {
        return super.get('/data', {
            templateName,
            isAvailable,
            currentPage,
            pageSize,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }

    save({ id, templateName, templateStart, remarks, evaluateList, isAvailable } = {}) {
        return super.post('/save', {
            id,
            templateName,
            templateStart,
            remarks,
            isAvailable,
            evaluateJson: JSON.stringify(evaluateList),
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }
}

export default new EvaluateTemplate();
export { EvaluateTemplate };
